import { useMainSelector } from './useMainSelector';

export function useCurrentUser() {
  return useMainSelector((state) => state.currentUser);
}
